import { sleep } from './sleep';

export async function retryFetch(
  url: string | URL,
  init: RequestInit = {},
  retryOptions: {
    retries?: number;
    retryDelay?: number;
  } = {},
): Promise<{
  response: globalThis.Response | null;
  error: Error | null;
}> {
  const { retries = 3, retryDelay = 1000 } = retryOptions;
  const signal = init.signal;
  const method = init.method ? init.method.toUpperCase() : 'GET';

  let tries = 0;
  let lastError: Error | null = null;
  let lastResponse: globalThis.Response | null = null;
  while (retries >= tries) {
    lastResponse = null;
    lastError = null;

    let statusCode = 0;
    try {
      lastResponse = await fetch(url, init);
      statusCode = lastResponse.status;

      if (lastResponse.ok) {
        return {
          response: lastResponse,
          error: null,
        };
      }

      // Everything below 420 is validation errors
      if ((statusCode && statusCode < 420) || method !== 'GET') {
        break;
      }
    } catch (err: any) {
      lastError = err;
    }

    if (signal && signal.aborted) {
      break;
    }

    if (retryDelay > 0) {
      await sleep(retryDelay);
    }

    tries += 1;
  }

  return {
    error: lastError,
    response: lastResponse,
  };
}
